import urlConfig from 'Url';

export const CLEAR_COST = 'CLEAR_COST';
export const SAVE_COST = 'SAVE_COST';
export const GET_REFUND_FEE = 'GET_REFUND_FEE';
export const SUBMIT_CHANGE_APPLY = 'SUBMIT_CHANGE_APPLY';
export const SUBMIT_VOLCHANGE_APPLY = 'SUBMIT_VOLCHANGE_APPLY';
export const SUBMIT_REFUND_APPLY = 'SUBMIT_REFUND_APPLY';
export const GET_NAME_PHONE = 'GET_NAME_PHONE';
export const CHECK_CODE = 'CHECK_CODE';
export const SAVE_REFUND_WAY = 'SAVE_REFUND_WAY';
export const GET_REFUND_WAY = 'GET_REFUND_WAY';
export const GET_VERIFICATION = 'GET_VERIFICATION';
export const CHECK_VERIFICATION_CODE = 'CHECK_VERIFICATION_CODE';
export const SHOW_EIENTRANCE = 'SHOW_EIENTRANCE';
export const GET_REFUND_RULES = 'GET_REFUND_RULES';
export const CREATE_E2E_CHANGE = 'CREATE_E2E_CHANGE';
export const CREATE_MU_CHANGE = 'CREATE_MU_CHANGE';
export const CREATE_GP_CHANGE = 'CREATE_GP_CHANGE';
export const SUMBIT_CHANGE_ADDPSGSINFO = 'SUMBIT_CHANGE_ADDPSGSINFO';
export const CHECK_ISNEEDPSGINFO = 'CHECK_ISNEEDPSGINFO';
export const CHECK_PNRDOCS = 'CHECK_PNRDOCS';
export const GET_INSURANCEC_CHANGE = 'GET_INSURANCEC_CHANGE';
export const GREEN_FLIGHT_SERVE = 'GREEN_FLIGHT_SERVE';
export const IS_GREEN_SWITCHON = 'IS_GREEN_SWITCHON';
export const GET_PACKAGE_DATE = 'GET_PACKAGE_DATE';
export const GET_ENCRYP_FLIGHTS = 'GET_ENCRYP_FLIGHTS';
export const GET_OVERTIME_B = 'GET_OVERTIME_B';
export const GET_CIVIL_SWITCH = 'GET_CIVIL_SWITCH';
export const GET_PHONEAREA_CODE = 'GET_PHONEAREA_CODE';
export const GET_ALL_SWITCH = 'GET_ALL_SWITCH';
export const GET_AREA_CODE = 'GET_AREA_CODE';
export const MU_CONTACT_INFO ='MU_CONTACT_INFO'
export function createGPChange(data) {
  return {
    type: CREATE_GP_CHANGE,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.createGPChange,
        method: 'post',
        data,
      },
    },
  };
}

// 清空联系人和费用详情
export function clearCost() {
  return { type: CLEAR_COST };
}

// 创建E2E单
export function createE2EChange(data) {
  return {
    type: CREATE_E2E_CHANGE,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.createE2EChange,
        method: 'post',
        data,
      },
    },
  };
}


// 创建东航变更单
export function createMuChange(data) {
  return {
    type: CREATE_MU_CHANGE,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.createMuChange,
        method: 'post',
        data,
      },
    },
  };
}

// 提交变更申请
export function submitApply(data, load, vol, artificialFlag = '') {
  if (artificialFlag) data.changeVO.reissueFlag = artificialFlag;
  return {
    type: SUBMIT_CHANGE_APPLY,
    closeLoading: load,
    payload: {
      request: {
        url: vol
          ? urlConfig.afterSaleVolChangeReqPayOK
          : urlConfig.afterSaleChangeReqPayOK,
        method: 'post',
        data,
      },
    },
  };
}

/**
 * @description 补充旅客信息提交变更
 */
export function submitChangeAddPsgsInfoApply(isArtificial, data) {
  return {
    type: SUMBIT_CHANGE_ADDPSGSINFO,
    closeLoading: true,
    payload: {
      request: {
        url: !isArtificial
          ? urlConfig.afterSaleChangeReqPayOK
          : urlConfig.createE2EChange,
        method: 'post',
        data,
      },
    },
  };
}

/**
 * @description 校验国际票是否需要补充旅客信息
 */
export function checkIsNeedPsgsInfo(data) {
  return {
    type: CHECK_ISNEEDPSGINFO,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.touchConfirmIntVol,
        method: 'post',
        data,
      },
    },
  };
}

/**
 * @description 重新录入信息校验
 */
export function checkIsNeedPNRPsgsInfo(data) {
  return {
    type: CHECK_PNRDOCS,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.checkPnrDocs,
        method: 'post',
        data,
      },
    },
  };
}

// 提交退票申请
export function submitApplyRefund(data) {
  return {
    type: SUBMIT_REFUND_APPLY,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.afterSaleRefundApp,
        method: 'post',
        data,
      },
    },
  };
}

// 获取退票费
export function getRefundFee(data) {
  return {
    type: GET_REFUND_FEE,
    payload: {
      request: {
        url: urlConfig.afterSaleRefundFee,
        method: 'post',
        data,
      },
    },
  };
}

// 获取退改规则
export function getRefundRules(data) {
  return {
    type: GET_REFUND_RULES,
    closeLoading: true,
    payload: {
      request: {
        url: urlConfig.getOriginFlightUseCondition,
        method: 'get',
        params: data,
      },
    },
  };
}

// 保存退票信息
export function saveCost(data) {
  return { type: SAVE_COST, data };
}

// 获取联系信息
export function getNameAndPhone(data, load = false) {
  return {
    type: GET_NAME_PHONE,
    closeLoading: load,
    payload: {
      request: {
        url: urlConfig.getNameAndPhone,
        method: 'post',
        data,
      },
    },
  };
}

// 获取短信验证码
export function getVerification(data) {
  return {
    type: GET_VERIFICATION,
    payload: {
      request: {
        url: urlConfig.getVerificationCode + '?type=change',
        method: 'post',
        data,
        headers: { 'Content-Type': 'application/json' },
      },
    },
  };
}

// 2018.03.16 获取行程单回收通知
// export function getStrokeNotice (data, cb) {
//   return dispatch => {
//     return api.callApiPost(
//       {
//         url: urlConfig.strokeNotice,
//         querys: data,
//         success: function (result) {
//           cb(result.receiptMsg)
//           return result
//         }
//       },
//       false
//     )
//   }
// }

// 退票前短信验证
export function checkVerificationCode(data) {
  return {
    type: CHECK_VERIFICATION_CODE,
    payload: {
      request: {
        url: urlConfig.checkVerificationCode,
        method: 'post',
        data,
      },
    },
  };
}

// 保存付款方式
export function saveRefundWay(data) {
  return { type: SAVE_REFUND_WAY, data };
}

// 获取退款方式
export function getRefundWay(data) {
  return {
    type: GET_REFUND_WAY,
    payload: {
      request: {
        url: urlConfig.getRefundMode,
        method: 'post',
        data,
      },
    },
  };
}

// 是否展示电子发票
export function showEiEntrance(data) {
  return {
    type: SHOW_EIENTRANCE,
    payload: {
      request: {
        url: urlConfig.showEiEntrance,
        method: 'post',
        data,
      },
    },
  };
}
// 获取保险产品
export function getInsurancecChange(data) {
  return {
    type: GET_INSURANCEC_CHANGE,
    payload: {
      request: {
        url: urlConfig.getInsurancecChange,
        method: 'post',
        data,
      },
    },
  };
}

// 获取绿色飞行产品
export function greenFlightServe(data) {
  return {
    type: GREEN_FLIGHT_SERVE,
    payload: {
      request: {
        url: urlConfig.greenFlightServe,
        method: 'post',
        data,
      },
    },
  };
}

export function isGreenSwitchOn(data) {
  return {
    type: IS_GREEN_SWITCHON,
    payload: {
      request: {
        url: urlConfig.isGreenSwitchOn,
        method: 'post',
        data,
      },
    },
  };
}

export function getPackageDate(data) {
  return {
    type: GET_PACKAGE_DATE,
    payload: {
      request: {
        url: urlConfig.getPackageDate,
        method: 'post',
        data,
      },
    },
  };
}

export function getEncrypFlights(data) {
  return {
    type: GET_ENCRYP_FLIGHTS,
    payload: {
      request: {
        url: urlConfig.encrypFlights,
        method: 'post',
        data,
      },
    },
  };
}

export function getOverTime_B() {
  return {
    type: GET_OVERTIME_B,
    payload: {
      request: {
        url: urlConfig.memberSystemSwitch,
        method: 'post',
        data: {
          switchKey: 'EXTRA_EMP_LOADTIME',
        },
      },
    },
  };
}
export function getCivilSwitch(val) {
  return {
    type: GET_CIVIL_SWITCH,
    payload: {
      request: {
        url: urlConfig.memberSystemSwitch,
        method: 'post',
        data: {
          switchKey: val,
        },
      },
    },
  };
}

export function getPhoneAreaCode() {
  return {
    type: GET_PHONEAREA_CODE,
    payload: {
      request: {
        url: '/public/phoneAreaCode.json',
        method: 'get',
      },
    },
  };
}

export function getAllSwitch(val) {
  return {
    type: GET_ALL_SWITCH,
    payload: {
      request: {
        url: urlConfig.memberAllSwitch,
        method: 'post',
        data: {
          switchKeys: val,
        },
      },
    },
  };
}

export function getAreaCodeList(data) {
  return {
    type: GET_AREA_CODE,
    payload: {
      request: {
        url: urlConfig.getAreaCodeList,
        method: 'post',
        data,
      },
    },
  };
}


export function muContactInfo(data) {
  return { type: MU_CONTACT_INFO, data };
}



// WEBPACK FOOTER //
// ./src/routes/routes/applySubmit/modules/actions.js